import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthConfig } from "angular-oauth2-oidc";
import { isDevMode } from '@angular/core';


@Injectable()
export class LoadConfigService {
    constructor(private http: HttpClient){
        
    }
    

    public loadConfig():Observable<ClientAppSettings>{
        let url;

        //url = "https://devportal.parseport.com/settings";
        url = "/settings";
        
        return this.http.get<ClientAppSettings>(url);
    }


    
}




export interface ClientAppSettings{
    stsServer:string,
    redirect_url:string,
    client_id:string,
    response_type:string,
    scope:string,
    post_logout_redirect_uri:string,
    start_checksession:string,
    silent_renew:string,
    startup_route:string,
    forbidden_route:string,
    unauthorized_route:string,
    log_console_warning_active:boolean,
    log_console_debug_active:boolean,
    max_id_token_iat_offset_allowed_in_seconds:string,
    apiServer:string
}